// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"y2-z","colorTextValue":"z2-z","swatches":"A2-z","collapseLink":"B2-z","isCollapsed":"C2-z","dropdown":"D2-z","disabled":"E2-z"};